
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const USB_TOAST_ID = "usb-connection-error";
const ShowUSBToast = (Title: string="Error reading from device.", MessageDesc: string = "If the PhotonMaster's red light was not lit while reading, refresh the browser and try again.") => {
    return (
        <div style={{ 
            display: 'flex', 
            flexDirection: 'row', 
            alignItems: 'center',
            justifyContent: 'flex-start', 
            backgroundColor: '#FFF4E5',
            borderRadius: '5px',
            width: '290px',
        }}>
            
            <div style={{ textAlign: 'left' }}> 
            <strong style={{ 
                    fontSize: '16px', 
                    color: '#CE0E0E',
                    fontFamily: 'Jost'
                }}>{Title}</strong>
                <p style={{ 
                    fontSize: '14px', 
                    color: '#CE0E0E',
                    fontFamily: 'Jost',
                    paddingTop:'8px'
                }}>{MessageDesc}</p>
            </div>
        </div>
    );
};
export const USBToast = (title?: string, message?: string, ID: string = USB_TOAST_ID, autoCloses?: boolean,) => {
    if (toast.isActive(ID)) return;
    toast(ShowUSBToast(title, message), {
        toastId: ID,
        position: 'bottom-left',
        autoClose: autoCloses === false ? false : 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: 'toast-background-color-usb',
    });
};

export default USBToast;
